import { sitestatusChange } from '../LccStore';
import { userChange } from '../UserState';
import { svc } from './sitesvc';

export async function site_status(): Promise<boolean> {
	const sitestatus = await svc.status();
	sitestatusChange({ sitestatus });
	userChange({ sitestatus });
	return true;
}
